/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import api from 'api';
import { Header, SideMenu, ReportItem, Search, Button, Dialog, Select } from 'components';
import {
  Container,
  ContentArea,
  Title,
  Div,
  DataArea,
  LoadingArea,
  CountArea,
  ModalButton,
  FilterModalForm,
  FilterDivPicker,
  FilterLabel,
} from './styles';
import { loadingColor, primary } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';

function ReportList() {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [reportsList, setReportsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [search, setSearch] = useState();
  const [open, setOpen] = useState(false);
  const [selectBaixada, setSelectBaixada] = useState('all');
  const [startData, setStartData] = useState(null);
  const [endData, setEndData] = useState(null);
  const [touchFilter, setTouchFilter] = useState();

  const formatDateParam = (date) => (date ? moment(date).format('DD/MM/YYYY') : undefined);

  const loadData = async () => {
    setLoading(true);
    setCurrentPage(1);

    const resp = await api({
      method: 'GET',
      url: `/broker-reports`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      params: {
        search,
        startdate: formatDateParam(startData),
        enddate: formatDateParam(endData),
        baixada: selectBaixada === 'all' ? undefined : selectBaixada,
        page: 1,
        take: 10,
      },
      json: true,
    });

    setReportsList(resp?.data?.reports);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
    setTouchFilter(false);
  };

  const handleLoadMore = async () => {
    if (!touchFilter) {
      const page = currentPage + 1;
      if (hasNextPage && !loadingMore) {
        setLoadingMore(true);

        const resp = await api({
          method: 'GET',
          url: `/broker-reports`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          params: {
            search,
            startdate: formatDateParam(startData),
            enddate: formatDateParam(endData),
            baixada: selectBaixada === 'all' ? undefined : selectBaixada,
            page,
            take: 10,
          },
          json: true,
        });

        const data = reportsList;
        const ndata = data.concat(resp?.data?.reports);

        setCurrentPage(page);
        setReportsList(ndata);
        setHasNextPage(resp?.data?.hasNextPage);
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectBaixada('all');
    setStartData(null);
    setEndData(null);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleOpenFilter = () => {
    setOpen(true);
  };

  const renderFilterDialog = () => (
    <Dialog open={open} onClose={() => setOpen(false)} width="50%" title="Filtrar relatórios">
      <FilterModalForm>
        <Select height="30px" label="Parcelas baixadas" value={selectBaixada} onChange={(e) => setSelectBaixada(e.target.value)}>
          <option value={'all'}>Todas</option>
          <option value={'true'}>Baixadas</option>
          <option value={'false'}>Não baixadas</option>
        </Select>

        <FilterDivPicker>
          <FilterLabel>Data inicial:</FilterLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              emptyLabel="DD/MM/AAAA"
              value={startData}
              onChange={setStartData}
              inputVariant="filled"
              format="dd/MM/yyyy"
              invalidDateMessage="Data inválida"
            />
          </MuiPickersUtilsProvider>
        </FilterDivPicker>

        <FilterDivPicker>
          <FilterLabel>Data final:</FilterLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              emptyLabel="DD/MM/AAAA"
              value={endData}
              onChange={setEndData}
              minDate={startData || undefined}
              inputVariant="filled"
              format="dd/MM/yyyy"
              invalidDateMessage="Data inválida"
            />
          </MuiPickersUtilsProvider>
        </FilterDivPicker>
      </FilterModalForm>

      <ModalButton>
        <Button
          height="35px"
          outlined
          disabled={selectBaixada === 'all' && !startData && !endData}
          onClick={handleClear}
        >
          Limpar filtros
        </Button>
        <Button
          height="35px"
          onClick={() => {
            setTouchFilter(true);
            loadData();
            setOpen(false);
          }}
        >
          Aplicar alterações
        </Button>
      </ModalButton>
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderFilterDialog()}

        <SideMenu />

        <ContentArea>
          <Div>
            <Title>RELATÓRIOS</Title>
            <div className="containerTitle">
              <Button title="Filtrar" height="30px" onClick={handleOpenFilter}>
                <TiFilter size={18} />
              </Button>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>

          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <div style={{ width: '100%' }}>
                {loading && (
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                )}
                {!loading &&
                  reportsList?.map((report) => (
                    <ReportItem
                      key={report.id}
                      report={report}
                    />
                  ))}
              </div>
            </InfiniteScroll>

            {!loading && !reportsList?.length && <p>Nenhum relatório encontrado</p>}
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {reportsList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default ReportList;
